import React, {useEffect,useState} from 'react';   
import { Link } from 'react-router-dom'; 
import { useSelector } from 'react-redux'; 
 import paths from '../../routes/paths'; 
 import ProductFiltersLeft from './ProductFiltersLeft'; 
import Product from './Product';
import DefaultPagination from '../Common/Pagination';
import Spinner from '../Common/Spinner';
import MetaTags from '../Common/MetaTags';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 
import "swiper/css/autoplay"; // Ensure this is imported

import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// import required modules

const  Products = () => { 
  const [products, setProducts] =  useState<any[]>([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [subcategories, setSubcategories] = useState([]);
  const [selPriceRange, setSelPriceRange] = useState('');
  const [selSearchTxt, setSelSearchTxt] = useState('');
  const [selCategory, setSelCategory] = useState('');
  const [loading, setLoading] = useState(true); 
  const {categories} = useSelector((state:any) => state.settings) 
 
 
  useEffect(() => {
    fetchAllProducts(currentPage);
  }, [currentPage]);

 

  const fetchAllProducts = async (page) => {
    setLoading(true);
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products?subcategory=Sarees&page=${page}&per_page=40&category=&searchTxt=`);
      
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json(); // Parse the JSON data
      setProducts(data.data);
      setTotalPages(data.total_pages);
      setSubcategories(data.saree_subsubcategories)
    //  setCategories(data.categories);
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0)
  };

  const searchFilters = async ( selectedCategory,selectedSearchTxt,selectedPriceRange) => {
    setLoading(true);
    setSelCategory(selectedCategory );
    setSelPriceRange(selectedPriceRange);
    setSelSearchTxt(selectedSearchTxt);
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products?subcategory=Sarees&page=${currentPage}&per_page=40&category=${selectedCategory}&priceRange=${selectedPriceRange}&searchTxt=${selectedSearchTxt}`);
      
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json(); // Parse the JSON data
      setProducts(data.data);
      setTotalPages(data.total_pages);
      setSubcategories(data.saree_subsubcategories)
      //setCategories(data.categories);

    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setLoading(false);
    }
  }

  const image_path = (name) => {
    return name.replace(/\s/g, "") + '.jpg'
  }

  //console.log("xxxxxxxxxxxxxx products current page",selSearchTxt,  selPriceRange, selCategory, subcategories)
  return (
    <>
       <MetaTags
        title={products[0]?.['category']['meta_title']}
        description={products[0]?.['category']['meta_description']}
        url="https://www.anuughacollections.com/sarees"
        image={process.env.REACT_APP_SERVER_URL + ( products[0]?.variants[0].variant_images[0]?.display_image_url)}
      />
      <div className="page-content bg-light">
        <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
          <div className="container">
            <div className="dz-bnr-inr-entry">
              <h1>All Sarees</h1>
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={paths.store} className="menu-title"> Home </Link></li>
                  <li className="breadcrumb-item"> All Sarees </li>
                </ul>l
              </nav>
            </div>
          </div>	
        </div>

        <section className="content-inner-3 pt-3 z-index-unset">
          <div className="container-fluid">
            <div className="row">
                <ProductFiltersLeft categories={categories} searchFilters={searchFilters}  selCategory={selCategory} selPriceRange={selPriceRange} selSearchTxt={selSearchTxt} />
                <div className="col-80 col-xl-9">
                <h4 className="mb-3">Category</h4>
                <div className="row">
                  <div className="col-xl-12"> 
                    {subcategories?.length > 5 && 
                      <Swiper
                               spaceBetween={30}
                              // slidesPerView={5}
                               //centeredSlides={true}
                               loop={true}
                               autoplay={{
                                 delay: 1500,
                                 disableOnInteraction: false,
                               }}
                               navigation={true}
                               
 
                          modules={[Autoplay,Navigation,Pagination]}
                        breakpoints={{
                          320: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                          },                          
                          640: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                          },
                          768: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                          },
                          1024: {
                            slidesPerView: 3,
                            spaceBetween: 50,
                          },
                          1280: {
                            slidesPerView: 5,
                            spaceBetween: 60,
                          },
                        }}
                        className="mySwiper"
                      >
                        { subcategories.map((category,index) =>
                      
                          <SwiperSlide key={index}> 
                             <div className="shop-card">
                              <div className="dz-media rounded">
                                <a href={paths.subCategories(category['slug'])} className="stext-107 cl7 hov-cl1 trans-04">      
                                  <img src={image_path(category['name'])} alt="product" loading="lazy"/> 
                                </a>					
                              </div>
                                <div className="dz-content">
                                  <h6 className="title">
                                      <a href={paths.subCategories(category['slug'])} className="stext-107 cl7 hov-cl1 trans-04">
                                          { category['name'] } 
                                      </a>
                                  </h6>
                                </div>
                             </div> 
                          </SwiperSlide> 
                     
                        )}  
                        
                        
                      </Swiper>
                      }
										
                  </div>
                </div>
                <div className="filter-wrapper border-top p-t20">
                  <div className="filter-left-area">								
                    <ul className="filter-tag">
                    {selPriceRange && selPriceRange !== 'All' && 
                      <li>
                        <button onClick={() => searchFilters(selCategory, selSearchTxt, '')} className="tag-btn">{selPriceRange} 
                          <i className="icon feather icon-x tag-close"></i>
                        </button>
                      </li>
                    }
                      {selCategory &&  selCategory !== "All" &&
                        <li>
                          <button onClick={() => searchFilters('', selSearchTxt, selPriceRange)} className="tag-btn">{selCategory} 
                            <i className="icon feather icon-x tag-close"></i>
                          </button>
                        </li>
                      }
                      {selSearchTxt && 
                        <li>
                           <button onClick={() => searchFilters(selCategory, '', selPriceRange)} className="tag-btn">{selSearchTxt} 
                            <i className="icon feather icon-x tag-close"></i>
                          </button>
                        </li>}
                      { (selCategory === ''  || selCategory === 'All' ) && (selPriceRange === "" || selPriceRange === "All") && (selSearchTxt ==='' || selSearchTxt === 'All') && 
                      (
                        <li>
                          <button className="tag-btn"> All Sarees </button>
                        </li>
                      )

                      }
                    </ul>
                    <span>Showing Page {currentPage} of {totalPages} Pages.</span>
                  </div>
                  
                </div>
                
                <div className="row">
                  <div className="col-12 tab-content shop-" id="pills-tabContent">
                    <div className="tab-pane fade active show" id="tab-list-grid" role="tabpanel" aria-labelledby="tab-list-grid-btn">
                      {loading ? (
                        <Spinner/>
                      ) : (
                            <div className="row gx-xl-4 g-3">
                              {products && products.map((product,index) => 
                                <Product key={index} product={product} index={index}/> 
                              )}
                            </div>
                          )}
                    </div>
                  </div>
                </div>
                
                {loading ? (''
                      ) : (
                  <div className="row page mt-0">
                    <div className="col-md-6">
                      <p className="page-text">Showing 1–5 Of {totalPages} Results</p>
                    </div>
                    <div className="col-md-6">
                  
                      <DefaultPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    {products.length === 0 &&  
                      <div className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 m-md-b15 m-b30">
                          <div className="shop-card style-1">No Products.</div>
                      </div>
                    }
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section> 
        {/* {selectedProduct  && <ProductViewModal selectedProduct={selectedProduct} modalShow={modalShow} onClose={handleModalClose} wishListData={manageWishList} wishlistIds={wishlist_ids}/>}
        {loginModalShow && <LoginModal modalShow={loginModalShow} onClose={handleLoginModalClose} />}
        */}
      </div> 
    </>
  );
}

export default Products;

 
